<template>
  <div id="app">
    <transition :name="transitionName" mode="out-in">
      <keep-alive>
        <router-view :key="`page-${$route.path}`" />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import objectFitImages from 'object-fit-images'
  import responsive from '@/mixins/responsive'
  import appendAdditionalScripts from '@/assets/js/appendScripts'

  export default {
    name: 'App',
    mixins: [responsive],

    data () {
      return {
        componentReady: false,
        transitionName: 'slide-to-right'
      }
    },

    computed: {
      ...mapState({
        scripts: state => state.general.scripts
      })
    },

    watch: {
      $route (to, from) {
        let toDepth = to.path.split('/').length
        let fromDepth = from.path.split('/').length

        toDepth = to.path === '/' ? 0 : toDepth
        fromDepth = from.path === '/' ? 0 : fromDepth

        let goToLeft = toDepth < fromDepth

        if (to.path === '/policy' || to.path === '/thank-you') {
          goToLeft = false
        }

        if (from.path === '/policy' || from.path === '/thank-you') {
          goToLeft = true
        }

        this.transitionName = goToLeft
          ? 'slide-to-left' : 'slide-to-right'

        if (document.querySelector('body')) {
          document.querySelector('body').scrollTop = 0
        }
      }
    },

    async mounted () {
      await this.fetchGeneralData()

      appendAdditionalScripts(this.scripts)

      const hasHover = window.matchMedia('(hover: hover)').matches
      if (hasHover) {
        document.documentElement.classList.add('has-hover')
      }

      objectFitImages() // object-fit polyfill

      this.componentReady = true

      if (this.$route.query.city) {
        this.$store.commit('SET_ALIAS_PARAM_CITY', this.$route.query.city)

        if (this.$route.query.dealer) {
          this.$store.commit('SET_ALIAS_PARAM_DEALER', this.$route.query.dealer)
        }
      }
    },

    methods: {
      ...mapActions(['fetchGeneralData'])
    }
  }
</script>

<style lang="scss">
  #app {
    padding: 100px 0;

    @include mobile {
      padding: 60px 0;
    }
  }

  .modals {
    z-index: 999999;
    position: fixed;
  }
</style>
